import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TBctxHeaderItem, TVariableGroupFieldsInfo } from '@monorepo/types';

@Component({
  selector: 'monorepo-bctx-header',
  templateUrl: './bctx-header.component.html',
  styleUrls: ['./bctx-header.component.scss'],
})
export class BctxHeaderComponent implements OnInit, OnChanges {
  @Input() bctxHeader: TBctxHeaderItem[] = [];
  @Input() enableSearch: boolean = false;
  @Input() enableBack: boolean = false;
  @Input() background: string = '';
  @Input() variableGroupFieldsInfo: TVariableGroupFieldsInfo[] = [];
  @Output() onSearch = new EventEmitter<string>();
  @Output() onBack = new EventEmitter<string>();

  styles = {};
  backArrow = '/assets/md-point/header-back-arrow.svg';
  filterIcon = '/assets/md-point/size-filter.svg';
  undoIcon = '/assets/md-points/undo-icon.svg';
  longArrowRight = '/assets/common/long-arrow-right.svg';

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['variableGroupFieldsInfo']) {
      this.variableGroupFieldsInfo = changes['variableGroupFieldsInfo'].currentValue;
    }
  }

  ngOnInit(): void {
    if (this.background) {
      this.styles = {
        ...this.styles,
        '--background': this.background,
        'border-radius': '8px',
        padding: '8px 0',
      };
    }
    console.log('[styles]', this.styles);
  }

  handleOnSearch() {
    this.onSearch.emit('SEARCH');
  }

  handleBack() {
    this.onBack.emit('BACK');
  }
}
